export const navMembershipMenu = [
  [
    {
      key: 'membership:1',
      url: 'https://carolinas.aaa.com/membership/',
      label: 'AAA Membership',
    },
    {
      key: 'membership:2',
      url: 'https://carolinas.aaa.com/membership/guide/',
      label: 'Membership Benefits',
    },
    {
      key: 'membership:3',
      url: 'https://join.carolinas.aaa.com/?promo=INTRNET',
      label: 'Join Now',
    },
    {
      key: 'membership:14',
      url: 'https://www.aaa.com/family/',
      label: 'Add a Family Member',
    },
    {
      key: 'membership:4',
      url: 'https://carolinas.aaa.com/membership/renew/',
      label: 'Renew Membership',
    },
    {
      key: 'membership:5',
      url: 'https://carolinas.aaa.com/membership/auto-renewal/',
      label: 'Automatic Renewal',
    },
    {
      key: 'membership:6',
      url: 'https://carolinas.aaa.com/membership/plans/',
      label: 'Pricing',
    },
  ],
  [
    {
      key: 'membership:7',
      url: 'https://carolinas.aaa.com/membership/renew',
      label: 'Upgrade Plan',
    },
    {
      key: 'membership:8',
      url: 'https://join.carolinas.aaa.com/transfer',
      label: 'Transfer to AAA Carolinas',
    },
    {
      key: 'membership:9',
      url: 'https://carolinas.aaa.com/membership/gift/',
      label: 'Gift Membership',
    },
    {
      key: 'membership:10',
      url: 'https://carolinas.aaa.com/membership/corporate-memberships/',
      label: 'Group Membership',
    },
    {
      key: 'membership:11',
      url: 'https://AAA.com/MemberHandbook',
      label: 'Membership Guide',
    },
    {
      key: 'membership:12',
      url:
        'https://aaacdndev.blob.core.windows.net/wordpress/2021/03/158701-Member-Guide-2021-1.pdf',
      label: 'Terms & Conditions',
    },
    {
      key: 'membership:13',
      url: 'https://www.aaa.com/bicycle',
      label: 'Bicycle Service',
    },
  ],
];

export const navMembershipPromo = [
  {
    title: 'Become a Member',
    content: 'Keep life moving on the road and beyond with AAA.',
    img: '',
    buttonText: 'Join Now',
    buttonUrl: 'https://join.carolinas.aaa.com/?promo=INTRNET',
  },
];
